import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import {query} from 'lit-element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '@modules/i18n';

/**
 * @summary DataTable
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('data-table')
class DataTable extends i18nMixin(AoflElement) {
  @query('ems-dropdown')
  selectDropdown;

  @property({type: String})
  selectionMode = null;

  /**
   * Creates an instance of DataTable.
   */
  constructor() {
    super();
    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static is = 'data-table';

  @property({type: Array, attribute: false, hasChanged(val, oldVal) {
      if (typeof oldVal === 'undefined') return false;
      return oldVal !== val;
  }})
  results = [];

  @property({type: Array, attribute: false})
  config = [];

  @property({type: Array, attribute: true})
  styles = [];

  @property({type: Boolean})
  ['select-all'] = false;

  @property({type: Boolean})
  ['disable-selection'] = false;

  @property({type: String})
  ['row-classlist'] = '';

  @property({type: String})
  ['aria-label'] = '';

  sortBy(e, index, item) {
    if (item.sortable !== true) return;
    this.dispatchEvent(new CustomEvent('change-sort', {
      detail: {index, item},
      composed: true
    }));
  }

  rowClicked(e, index, data) {
    this.dispatchEvent(new CustomEvent('row-click', {
      detail: {index, data, e: e},
      composed: true
    }));
  }

  rowToggle(e, index, data) {
    this.dispatchEvent(new CustomEvent('row-toggle', {
      detail: {index, data, checked: e.target.checked},
      composed: true
    }));
  }

  toggleSelectMenu(e) {
    e.preventDefault();
    e.stopPropagation();

    if (!this['select-all']) {
      this.selectDropdown.toggle(e);
    } else {
      this['select-all'] = false;
      this.dispatchEvent(new CustomEvent('all-toggle', {
        detail: {
          checked: false,
          selectionMode: this.selectionMode,
        },
        composed: true
      }));
      this.selectionMode = null;
    }
  }

  toggleAll(e, selectionMode) {
    this['select-all'] = !e.target.checked;
    this.dispatchEvent(new CustomEvent('all-toggle', {
      detail: {
        checked: this['select-all'],
        selectionMode
      },
      composed: true
    }));
  }

  togglePage(e, selectionMode) {
     this['select-all'] = !e.target.checked;
     this.dispatchEvent(new CustomEvent('page-toggle', {
      detail: {
        checked: this['select-all'],
        selectionMode
      },
      composed: true
    }));
  }



  togglePersistentSelection(e, selectionMode) {
    this.dispatchEvent(new CustomEvent('persistent-selection-toggle', {
      detail: {
        checked: this['select-all'],
        selectionMode
      },
      composed: true
    }));
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles, this.styles]}
    });
  }
}

export default DataTable;
